module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Introduction"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "id1516610"
    }
  }, [_vm._v("Introduction")])])])])]), _c('a', {
    attrs: {
      "id": "id1516610"
    }
  }, [_c('p', [_vm._v("When I told my mother I was working on a book about brilliance, I thought it would\n            make her proud. But as Mom’s blows rained down on me, I realized my mistake.")]), _vm._v(" "), _c('p', [_vm._v("“Will each copy of the book”—"), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("thwack!")])]), _vm._v("—“come with a boredom\n                suppressant”—"), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("pow!")])]), _vm._v("—“so that someone actually reads the blasted\n                thing?”—"), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("kerrang!")])]), _vm._v("—she demanded.")]), _vm._v(" "), _c('p', [_vm._v("At that moment, I realized two things: first, Mom had a mean right hook, and second, I\n            needed to share my definition of brilliance with her.")])]), _c('p', [_c('a', {
    attrs: {
      "id": "id1516610"
    }
  }, [_vm._v("Brilliance is one of the greatest of all civic virtues. After all, the more brilliant\n            citizens a nation has, the better off it is! That’s why free public education is\n            available in the United States, most of Europe, and in countries as diverse as Sri Lanka\n            and Australia. These are nations aspiring to well-informed, insightful citizens who make\n            intelligent decisions in the voting booth, the workplace, and the condiments aisle of\n            the supermarket.\n            "), _c('sup', [_vm._v("[")])]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "footnote",
    attrs: {
      "href": "#/#ftn.id1516655",
      "id": "id1516655"
    }
  }, [_vm._v("1")])]), _vm._v("]")]), _vm._v(" "), _c('p', [_vm._v("This book has been specially designed by scientists to cultivate your brilliance and\n            to encourage you to be a more engaged citizen. It does this by shining a light on the\n            United States. Not everyone has considered Americans as being brilliant. Innovative,\n            yes. Inventive, yes. Invasive, occasionally. Brilliant? Not so much. Benjamin Franklin\n            was certainly a bright fellow, but he once described a group of typical Americans as\n            “little better than Dunces and Blockheads.”")]), _vm._v(" "), _c('p', [_vm._v("My, that Franklin was a rascal! But I believe he was only partially correct, and so\n            the pages that follow are filled with instructive examples of geniuses, leaders, and\n            dunderheads, who together will guide us toward an understanding of what real\n            “brilliance” is. ")]), _vm._v(" "), _c('p', [_vm._v("I know what you’re thinking: “Is this some kind of tricky self-improvement plan?\n                "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("Bor-ring.")])]), _vm._v("” Not at all! Learning what happened\n                "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("when")])]), _vm._v(" and "), _c('span', {
    staticClass: "emphasis"
  }, [_c('em', [_vm._v("to whom")])]), _vm._v(" not only captures the\n            imagination, it’s also FUN. This book will make you look on today’s world in a new way,\n            helping you make brilliant conversation—and giving you a safer experience in the\n            condiment aisle!")]), _vm._v(" "), _c('p', [_vm._v("So keep reading and leave the relish to me.")]), _vm._v(" "), _c('div', {
    staticClass: "footnotes"
  }, [_c('br'), _c('hr'), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('sup', [_vm._v("["), _c('a', {
    staticClass: "para",
    attrs: {
      "href": "#/#id1516655",
      "id": "ftn.id1516655"
    }
  }, [_vm._v("1")]), _vm._v("] ")]), _vm._v("1. One false move there can be more dangerous than you think. The relish, my\n                    goodness, the relish!")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-716af6fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 72
// module chunks = 0